import { render, staticRenderFns } from "./insert_data.vue?vue&type=template&id=88b7921e&scoped=true"
import script from "./insert_data.vue?vue&type=script&lang=js"
export * from "./insert_data.vue?vue&type=script&lang=js"
import style0 from "./insert_data.vue?vue&type=style&index=0&id=88b7921e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b7921e",
  null
  
)

export default component.exports